import { TaskStateInWsNotif } from '../../shared/models/misc.model';
import { AsyncRequestResponse } from '../async-request/model';
import { WebSocketNotificationTypeEnum } from './web-socket-notification-type.enum';

export interface WebSocketNotification {
  type: WebSocketNotificationTypeEnum;
  data?: any;
}

export interface WebSocketActionNotification extends WebSocketNotification {
  type: WebSocketNotificationTypeEnum.Action;
  action_id: number;
  action_type: ActionType;
  conversation_id: number;
  from_user_id: number;
  message_id: number;
  site_id: number;
  task_id: number;
  log_answer_action_id?: number; // set iff type is EXECUTE_ANSWER
}

export interface WebSocketTaskNotification extends WebSocketNotification {
  type: WebSocketNotificationTypeEnum.Task;
  from_user_id?: number;
  routing_tag_id: number;
  scan_id: number;
  site_id: number;
  task_id: number;
  task_state: TaskStateInWsNotif;
  task_type: number;
  user_id: number;
}

export interface WebSocketAsyncRequestNotification extends WebSocketNotification {
  type: WebSocketNotificationTypeEnum.AsyncRequest;
  data: {
    id: number; // the id of the async request
    response: AsyncRequestResponse<any>;
  };
}

export enum ActionType {
  ARCHIVED = 0,
  ANSWERED = 1,
  AUTO_ARCHIVED = 2,
  TWITTER_FAVORITE = 3,
  TWITTER_UNFAVORITE = 4,
  TWITTER_RETWEET = 5,
  TWITTER_UNRETWEET = 6,
  TWITTER_FOLLOW = 7,
  TWITTER_UNFOLLOW = 8,
  TWITTER_BLOCK = 9,
  TWITTER_UNBLOCK = 10,
  FACEBOOK_LIKE = 11,
  FACEBOOK_UNLIKE = 12,
  FACEBOOK_HIDE = 13,
  FACEBOOK_UNHIDE = 14,
  FACEBOOK_DELETE = 15,
  COMMENT = 16,
  HELP_REQUEST = 17,
  HELP_ANSWER = 18,
  ACQUIRED = 19,
  RELEASED = 20,
  STEAL = 21,
  TWITTER_DELETE = 22,
  INSTAGRAM_FOLLOW = 23,
  INSTAGRAM_UNFOLLOW = 24,
  INSTAGRAM_BLOCK = 25,
  INSTAGRAM_UNBLOCK = 26,
  ASSIGNED_TO = 27,
  FIRST_SEEN = 28,
  FACEBOOK_BAN = 29,
  FACEBOOK_UNBAN = 30,
  TWITTER_PUBLISH = 31,
  FACEBOOK_PUBLISH = 32,
  TAG = 33,
  INSTAGRAM_DELETE = 34,
  INSTAGRAM_LIKE = 35,
  INSTAGRAM_UNLIKE = 36,
  ON_HOLD = 37,
  TASK_CREATED = 38,
  TAG_VIP = 39,
  UNTAG_VIP = 40,
  EXECUTE_ANSWER = 41,
  EXTRA_COMMENT = 42,
  MODIFIED = 43,
  INSTAGRAM2_HIDE = 44,
  INSTAGRAM2_UNHIDE = 45,
  INSTAGRAM2_DELETE_COMMENT = 46,
  INSTAGRAM2_ENABLE_MEDIA_COMMENT = 47,
  INSTAGRAM2_DISABLE_MEDIA_COMMENT = 48,
  WHATSAPP_DELETE = 49,
  BZC_DELETE = 50,
  BZC_CONVERSATION_CLOSE = 51,
  SMS_NOTIFICATION_SENT = 52,
  TWITTER_RETWEET_PUBLICATION = 53,
  GMB_DELETE = 54,
  TRUSTPILOT_FIND_REVIEWER = 55,
}

export const DELETE_ACTIONS = [
  ActionType.FACEBOOK_DELETE,
  ActionType.TWITTER_DELETE,
  ActionType.INSTAGRAM_DELETE,
  ActionType.INSTAGRAM2_DELETE_COMMENT,
  ActionType.WHATSAPP_DELETE,
  ActionType.BZC_DELETE,
  ActionType.GMB_DELETE,
];
